// extracted by mini-css-extract-plugin
module.exports = {"hero":"ProjectHero-module--hero--1kLNw","caption":"ProjectHero-module--caption--27PqC"};